export const SUCCESS_MESSAGES = [
  {
    type: "folder_created",
    message: "Folder Created Successfully!",
  },
  {
    type: "file_uploaded",
    message: "File Uploaded Successfully!",
  },
  {
    type: "rename_folder",
    message: "Folder Name Updated Successfully!",
  },
  {
    type: "rename_file",
    message: "File Name Updated Successfully!",
  },
  {
    type: "delete_file",
    message: "File Delete Successfully!",
  },
  {
    type: "delete_folder",
    message: "Folder Delete Successfully!",
  },
  {
    type: "hide_folder",
    message: "Folder Hide Successfully!",
  },
  {
    type: "hide_file",
    message: "File Hide Successfully!",
  },
  {
    type: "unHide_folder",
    message: "Folder Unhide Successfully!",
  },
  {
    type: "unHide_file",
    message: "File Unhide Successfully!",
  },
];
